const personal = {
  // page.tsx / JSON-LD
  'personal.jsonld.serviceName': 'Butler Training Programme — Campus-Based Course for Individuals',
  'personal.jsonld.orgName': 'The All Japan Butler Association',
  'personal.jsonld.serviceType': 'Butler Training Education',
  'personal.jsonld.areaServed': 'Japan',
  'personal.jsonld.description': 'A campus-based butler training programme for individuals at our Odaiba campus in Tokyo, teaching butler deportment systematically from the fundamentals. Held on weekends in small classes (max. \n\n6 students), with Essential, Advanced, and Master courses.',
  'personal.jsonld.breadcrumb1': 'Home',
  'personal.jsonld.breadcrumb2': 'For Individuals',

  // HeroSection (lead)
  'personal.hero.homeLink': 'Home',
  'personal.hero.currentPage': 'For Individuals',
  'personal.hero.title': 'Campus-Based Butler Training in Odaiba, Tokyo',
  'personal.hero.titleEn': 'FOR INDIVIDUALS — CAMPUS-BASED TRAINING',
  'personal.hero.lead': 'The Japan Butler Academy\'s courses for individuals take place at our Odaiba campus in Tokyo, where students learn butler deportment systematically from the fundamentals. Held on weekends in small classes (max. 6 students), the programme is designed to be accessible even to complete beginners.',
  'personal.hero.imgAlt': 'A student learning butler deportment at The Japan Butler Academy campus in Odaiba',
  'personal.hero.badge1': 'Weekend classes, small groups (max. 6 students)',
  'personal.hero.badge2': 'Three courses: Essential / Advanced / Master',
  'personal.hero.badge3': 'Association-certified credential on graduation',

  // CTA row at bottom
  'personal.cta.corporateNote': 'Considering training for your organisation?',
  'personal.cta.corporateLink': 'For Companies (On-Site Training)',
};

export default personal;
